import {
  SizeGuideSection
} from "../size-guide-section"

const bootsTableData = {
  headers: [
    [
      {
        content: "US Sizes",
      },
      {
        content: "Euro Sizes",
      },
      {
        content: "UK Sizes",
      },
      {
        content: "Inches",
      },
      {
        content: "CM",
      }
    ]
  ],
  data: [
    [
      {
        content: "6" 
      },
      {
        content: "39" 
      },
      {
        content: "5.5" 
      },
      {
        content: "9.3" 
      },
      {
        content: "23.5" 
      }
    ],
    [
      {
        content: "6.5" 
      },
      {
        content: "39" 
      },
      {
        content: "6" 
      },
      {
        content: "9.5" 
      },
      {
        content: "24.1" 
      }
    ],
    [
      {
        content: "7" 
      },
      {
        content: "40" 
      },
      {
        content: "6.5" 
      },
      {
        content: "9.6" 
      },
      {
        content: "24.4" 
      }
    ],
    [
      {
        content: "7.5" 
      },
      {
        content: "40-41" 
      },
      {
        content: "7" 
      },
      {
        content: "9.8" 
      },
      {
        content: "24.8" 
      }
    ],
    [
      {
        content: "8" 
      },
      {
        content: "41" 
      },
      {
        content: "7" 
      },
      {
        content: "9.9" 
      },
      {
        content: "25.4" 
      }
    ],
    [
      {
        content: "8.5" 
      },
      {
        content: "41-42" 
      },
      {
        content: "8" 
      },
      {
        content: "10.1" 
      },
      {
        content: "25.7" 
      }
    ],
    [
      {
        content: "9" 
      },
      {
        content: "42" 
      },
      {
        content: "8.5" 
      },
      {
        content: "10.3" 
      },
      {
        content: "26" 
      }
    ],
    [
      {
        content: "9.5" 
      },
      {
        content: "42-43" 
      },
      {
        content: "9" 
      },
      {
        content: "10.4" 
      },
      {
        content: "26.7" 
      }
    ],
    [
      {
        content: "10" 
      },
      {
        content: "43" 
      },
      {
        content: "9.5" 
      },
      {
        content: "10.6" 
      },
      {
        content: "27" 
      }
    ],
    [
      {
        content: "10.5" 
      },
      {
        content: "43-44" 
      },
      {
        content: "10" 
      },
      {
        content: "10.8" 
      },
      {
        content: "27.3" 
      }
    ],
    [
      {
        content: "11" 
      },
      {
        content: "44" 
      },
      {
        content: "10.5" 
      },
      {
        content: "10.9" 
      },
      {
        content: "27.9" 
      }
    ],
    [
      {
        content: "11.5" 
      },
      {
        content: "44-45" 
      },
      {
        content: "11" 
      },
      {
        content: "11.1" 
      },
      {
        content: "28.3" 
      }
    ],
    [
      {
        content: "12" 
      },
      {
        content: "45" 
      },
      {
        content: "11.5" 
      },
      {
        content: "11.3" 
      },
      {
        content: "28.6" 
      }
    ],
    [
      {
        content: "13" 
      },
      {
        content: "46" 
      },
      {
        content: "12.5" 
      },
      {
        content: "11.6" 
      },
      {
        content: "29.4" 
      }
    ],
    [
      {
        content: "14" 
      },
      {
        content: "47" 
      },
      {
        content: "13.5" 
      },
      {
        content: "11.9" 
      },
      {
        content: "30.2" 
      }
    ],
    [
      {
        content: "15" 
      },
      {
        content: "48" 
      },
      {
        content: "14.5" 
      },
      {
        content: "12.2" 
      },
      {
        content: "31" 
      }
    ]
  ]
}

export const Boots = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='Boots'
    tableData={bootsTableData}
    className={className}
  />
}
